import React from "react";
import { Box, Typography } from "@mui/material";
import { BoardTitle, MessageItem, MoreButton } from ".";
import { useTranslation } from "react-i18next";

type PropsType = {};

export const History: React.FC<PropsType> = (props) => {
  const { t } = useTranslation();
  const messages = [
    {
      time: "2012.01.05",
      tag: t("home.history.tag"),
      text: t("home.history.list.option1"),
      url: "",
    },
    {
      time: "2014.03.03",
      tag: t("home.history.tag"),
      text: t("home.history.list.option2"),
      url: "",
    },
    {
      time: "2019.09.01",
      tag: t("home.history.tag"),
      text: t("home.history.list.option3"),
      url: "",
    },
    {
      time: "2021.10.01",
      tag: t("home.history.tag"),
      text: t("home.history.list.option4"),
      url: "",
    },
    {
      time: "2022.01.01",
      tag: t("home.history.tag"),
      text: t("home.history.list.option5"),
      url: "",
    },
    {
      time: "2023.06.01",
      tag: t("home.history.tag"),
      text: t("home.history.list.option6"),
      url: "",
    },
  ];

  return (
    <Box
      sx={{
        width: "85%",
        margin: "0 auto",
        padding: "68px 0 40px",
        display: "flex",
        flexWrap: "wrap",
        "@media screen and (max-width: 900px)": { width: "100% !important" },
      }}
    >
      <Box
        width={0}
        sx={{
          "@media screen and (max-width: 900px)": { display: "none" },
        }}
      >
        <BoardTitle isLine>
          <Typography component="h2" fontSize={26} fontWeight="bold">
            {t("home.history.top_title")}
          </Typography>
          <Typography fontSize={16} fontWeight="bold" mt="10px">
            {t("home.history.bottom_title")}
          </Typography>
        </BoardTitle>
      </Box>
      <Box
        sx={{
          m: "0 auto 40px",
          textAlign: "center",
          "@media screen and (min-width: 900px)": { display: "none" },
        }}
      >
        <BoardTitle arrow="center" isLine>
          <Typography component="h2" fontSize={26} fontWeight="bold">
            {t("home.history.top_title")}
          </Typography>
          <Typography fontSize={16} fontWeight="bold" mt="10px">
            {t("home.history.bottom_title")}
          </Typography>
        </BoardTitle>
      </Box>
      <Box
        ml="20%"
        width="80%"
        mb="50px"
        sx={{
          "@media screen and (max-width: 900px)": { width: "100%", ml: 0 },
        }}
      >
        {(messages.length >= 3 ? messages.slice(0, 3) : messages).map(
          (item, index) => (
            <MessageItem
              key={index}
              item={item}
              isOdd={index % 2 === 0 ? true : false}
              isOmit
            />
          )
        )}
      </Box>
      <MoreButton text={t("home.history.list_url")} link="/history" isArrow />
    </Box>
  );
};
export default History;
